import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import _ from 'lodash'

import { sortOrders } from '../configuration/sorting'
import { useFilterTours } from './useFilterTours'
import { useSearchResults } from './useSearchResults'
import { getFilters } from '../redux/reducers/filters'
import { getSortOrder } from '../redux/reducers/sorting'

function useSortToursByField(tours, sortByKey) {
  return useMemo(() => {
    const sortByType = _.get(sortOrders, `[${sortByKey}]`)
    return sortByType
      ? _.orderBy(tours, [sortByType.field], [sortByType.order])
      : tours
  }, [tours, sortByKey])
}

export function useGetFilteredTours() {
  const filterState = useSelector(getFilters)
  const sortOrder = useSelector(getSortOrder)
  const tours = useSearchResults()

  let filteredTours = useMemo(() => _.map(tours), [tours])
  filteredTours = useFilterTours(filteredTours, filterState)
  filteredTours = useSortToursByField(filteredTours, sortOrder)

  return filteredTours
}
